import { apiClient } from '@/services/api/apiClient'

import type { LoginResponse } from '@/services/admin/types'
import type { Locale } from '@/types/site'

export async function login(email: string, password: string) {
  const { data } = await apiClient.post<LoginResponse>('/api/v1/auth/login', { email, password })
  return data
}

export async function loginWithGoogle(credential: string) {
  const { data } = await apiClient.post<LoginResponse>('/api/v1/auth/google', { credential })
  return data
}

export async function requestPasswordReset(email: string, locale: Locale) {
  await apiClient.post('/api/v1/auth/forgot-password', { email, locale })
}

export async function resetPasswordWithToken(payload: {
  email: string
  token: string
  password: string
  password_confirmation: string
}) {
  await apiClient.post('/api/v1/auth/reset-password', payload)
}

export async function logout() {
  await apiClient.post('/api/v1/admin/auth/logout')
}
